export default __webpack_public_path__ + "static/media/dots.720b146a.svg";